import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    padding: 0 ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }

    .title {
        font-size: ${rem(30)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.primary};
        display: block;
        text-align: center;
        padding-bottom: ${rem(25)};
        margin-top: ${rem(65)};
    }

    .subTitle {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        display: block;
        text-align: center;
        padding-bottom: ${rem(25)};
        
    }

    .sectionTitle {
        font-size: ${rem(18)};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        display: block;
        padding: ${rem(20)} 0;
        text-align: center;
}
    }

    .underline {
        text-decoration: underline;
    }

    .marginLeft {
        margin-left: ${rem(20)};
    }

    .section {
        a {
            color: ${({ theme }) => theme.colors.primary};
            padding-right: ${rem(4)};
            display: inline-flex;
        }
    }

    

`;

export const Content = styled.div`

    .vop { counter-reset: chapter; } 
    .vop > ol { counter-reset: section; list-style: none; padding-left: 0; margin: 0; } 
 
    .vop > ol > li { counter-increment: chapter; list-style: none; } 
    .vop > ol > li > h3::before { content: counter(chapter) ". "; } 
    
    .vop > ol > li > ol { counter-reset: section; list-style: none; padding-left: 20px; }
    .vop > ol > li > ol > li { counter-increment: section; list-style: none; position: relative; padding-left: 3.5em; } 
    .vop > ol > li > ol > li::before { content: counter(chapter) "." counter(section) "."; position: absolute; left: 0; top: 0; } 
    
    .vop > ol > li > ol > li > ol { counter-reset: subitem; list-style: none; padding-left: 2em; } 
    .vop > ol > li > ol > li > ol > li { counter-increment: subitem; list-style: none; position: relative; padding-left: 2em; } 
    .vop > ol > li > ol > li > ol > li::before { content: counter(subitem, lower-alpha) "."; position: absolute; left: 0; top: 0; } 
    .vop h1 { margin-bottom: 0; } 
    .vop h3 { margin-bottom: 1em; } 
    .vop p { margin-top: 0; line-height: 1.5;}
`;
